import { defineStore } from 'pinia'
import {services, getHeader, axios } from '@/assets/js/httpImports.js'

export const useApprovalStore = defineStore('approvalStore', {
    state:() => ({
        approval_count: 0,
    }),
    actions : {
        reduceCountPendingApproval(){
            if(this.approval_count > 0){
                this.approval_count -= 1
            }
        },
        async getCountPendingApproval(){
            try{
                const res = await axios.get(services.approval + 'approvals/count', {headers: getHeader()})
                this.approval_count = res.data.data.count
            }catch(e){
                console.log('Approval Store (getCountPendingApproval) failed:' + e)
            }
        },
    }
})